import { observable, action } from 'mobx';
import { InputModel } from '.';

export default class BindingGroupModel {
    @observable
    name: string;

    @observable
    enabled: boolean;

    @observable
    editable: boolean = false;

    @observable
    inputs: InputModel[] = [];

    @observable
    childBindingGroups: BindingGroupModel[] = [];

    @observable
    openChildBindingGroups: string[] = [];

    readonly bindingGroupId: string;

    constructor(bindingGroupId: string, name: string, enabled: boolean) {
        this.bindingGroupId = bindingGroupId;
        this.name = name;
        this.enabled = enabled;
    }

    @action.bound
    setName(name: string) {
        this.name = name.trim();
    }

    @action.bound
    setEnabled(enabled: boolean) {
        this.enabled = enabled;
    }

    @action.bound
    setEditable(editable: boolean) {
        this.editable = editable;
    }

    @action.bound
    setInputs(inputs: InputModel[]) {
        this.inputs = inputs;
    }

    @action.bound
    setChildBindingGroups(childBindingGroups: BindingGroupModel[]) {
        this.childBindingGroups = childBindingGroups;
    }

    @action.bound
    setOpenChildBindingGroups(openChildBindingGroups: string[]) {
        this.openChildBindingGroups = openChildBindingGroups;
    }

    getInputById(inputId: string): InputModel | undefined {
        return this.inputs.find(i => i.inputId === inputId);
    }
}
